import React from 'react'
import BannerBrandImageSection from '../../../bannerBrandImageSection'
import { IEstimateAcceptedStageProps } from '../stages/interfaces/IEstimateAcceptedStageProps'
import { FinAppStatusValue } from 'application/utils/type'
import { HomeStaticData } from '../homeStaticData'

const EstimateAcceptedStage = (props: IEstimateAcceptedStageProps) => {
  const { firstName, consultantFirstName, isConsultant, finAppStatus } = props

  const bannerContent = HomeStaticData('EstimateAcceptedBannerText', {
    consultantFirstName: consultantFirstName,
  })
  const finAppBannerContent = HomeStaticData(
    'EstimateAcceptedFinAppBannerText',
    {
      consultantFirstName: consultantFirstName,
    }
  )

  let isAtFinApp =
    finAppStatus.status == FinAppStatusValue.NOTSTARTED ||
    finAppStatus.status == FinAppStatusValue.STARTED

  const sectionTitle = `Hang tight ${firstName}, we're getting things ready for you`
  const sectionContent = `${bannerContent}
  ${isAtFinApp ? finAppBannerContent : ''}
  `

  const firstButton = {
    buttonName: isAtFinApp ? 'Start finance application' : '',
    disabled: isConsultant,
    linkUrl: finAppStatus.url,
  }

  return (
    <>
      <BannerBrandImageSection
        id="maincontent"
        sectionTitle={sectionTitle}
        sectionContent={sectionContent}
        firstButton={firstButton}
        showConsultantButton={!isConsultant}
        bannerImageName="Banner1"
      ></BannerBrandImageSection>
    </>
  )
}

export default EstimateAcceptedStage
